import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { QuantityShipping } from './QuantityShipping';
import { AvailableIcon, UnavailableIcon } from '../../helpers/icon-utils';

export const DefaultShipping = ({
  shippingMessageStyle, iconType, shippingMessage, displayQuantity, shippingThreshold
}) => {
  const iconSelector = iconType === 'close' ? <UnavailableIcon /> : <AvailableIcon />;
  const shippingCss = classNames(shippingMessageStyle + ' shipping__second-line');

  return (
    <div className="shipping__message">
      <div className="shipping__icon">
        {iconSelector}
      </div>
      <div className="shipping__text-box">
        <div className="shipping__dark">Delivery</div>
        {displayQuantity > 0 && (
          <QuantityShipping
            displayQuantity={displayQuantity}
            shippingMessageStyle={shippingMessageStyle}
            shippingMessage={shippingMessage}
            shippingThreshold={shippingThreshold}
          />
        )}
        {displayQuantity <= 0 && (
          <div className={shippingCss}>{shippingMessage}</div>
        )}
      </div>
    </div>
  );
};

DefaultShipping.propTypes = {
  shippingMessageStyle: PropTypes.string,
  shippingMessage: PropTypes.string,
  displayQuantity: PropTypes.number,
  iconType: PropTypes.string,
  shippingThreshold: PropTypes.number,
};

DefaultShipping.defaultProps = {
  shippingMessageStyle: 'shipping__primary',
  iconType: 'close',
  shippingMessage: 'Unavailable',
  displayQuantity: 0,
  shippingThreshold: null,
};
